export default __webpack_public_path__ + "static/media/patent1page1.46dabf81.jpg";